import { safeGetItem } from './storage';
const BASE = process.env.REACT_APP_API_URL || '/api';
// safeGetItem, non localStorage nudo: questa funzione la chiama ogni singola
// richiesta al server, e nel browser interno di Facebook localStorage puo'
// LANCIARE. Una sola eccezione qui fermava tutto (2026-09-02).
const getToken = () => safeGetItem('zv_token');
const auth = () => ({ Authorization: `Bearer ${getToken()}` });
// Le stesse intestazioni, per chi parla col server senza passare da qui: il
// caricamento a blocchi fa fetch a mano perche' manda byte grezzi.
export const intestazioniAuth = auth;
export const BASE_API = BASE;

// Auth
// attribution — { medium, utmSource, referrer, landingPage }, the first-touch
// fields beyond source/campaign (see frontend/src/utils/attribution.js).
// No username param — the form no longer collects one, the server derives
// it from the email (see routes/auth.js POST /register).
export const apiRegister = (p, s, email, encryptedKeyBackup, recoveryTokenHash, source, campaign, referralCode, attribution = {}, language, emailCheckMeta = {}) => post(`${BASE}/auth/register`, {
  password: p, salt: s, email, encryptedKeyBackup, recoveryTokenHash, source, campaign, referralCode,
  medium: attribution.medium, utmSource: attribution.utmSource, referrer: attribution.referrer, landingPage: attribution.landingPage,
  fbclid: attribution.fbclid, rdtCid: attribution.rdtCid, gclid: attribution.gclid, ttclid: attribution.ttclid,
  attributionCapturedAt: attribution.attributionCapturedAt,
  language,
  emailTypoSuggestionShown: emailCheckMeta.emailTypoSuggestionShown,
  emailTypoAccepted: emailCheckMeta.emailTypoAccepted,
  // Quale elemento del sito ha aperto la registrazione (slug corto, es.
  // 'hero_email', 'plans_2tb', 'fascia_offerta'); il server lo salva in
  // users.register_entry. Viaggia nel meta insieme ai segnali del typo.
  registerEntry: emailCheckMeta.registerEntry,
});
export const apiResendVerification = () => post(`${BASE}/auth/resend-verification`, {});
export async function apiVerifyEmail(token) {
  const res = await fetch(`${BASE}/auth/verify-email/${token}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Verification failed');
  return data;
}
export const apiLogin    = (u, p)    => post(`${BASE}/auth/login`, { username: u, password: p });
// signal (optional, 2026-08-30) — lets a caller impose its own per-attempt
// timeout via AbortController without a global fetch timeout affecting
// every other call in the app. First (and currently only) consumer:
// useAuth.js's session-restore retry loop, see its own comment for why.
export const apiMe       = (signal)  => get(`${BASE}/auth/me`, signal);
// Interruttori pubblici (2026-09-16): il recupero password e' aperto? Lo dice il server.
export const apiInterruttori = () => get(`${BASE}/auth/interruttori`);

// StackSocial redemption — check-code is read-only (never throws on a
// normal not-found/already-used/invalid result, only on rate-limit/server
// error), redeem mirrors apiRegister's shape plus the code field.
export const apiCheckStackSocialCode = (code) => get(`${BASE}/stacksocial/check-code?code=${encodeURIComponent(code)}`);
export const apiRedeemStackSocialCode = (email, password, salt, code, encryptedKeyBackup, recoveryTokenHash, language, emailCheckMeta = {}) =>
  post(`${BASE}/stacksocial/redeem`, {
    email, password, salt, code, encryptedKeyBackup, recoveryTokenHash, language,
    emailTypoSuggestionShown: emailCheckMeta.emailTypoSuggestionShown,
    emailTypoAccepted: emailCheckMeta.emailTypoAccepted,
  });
// Authenticated variant (2026-08-30) — applies a code to the ALREADY logged
// in account (post() attaches the session token automatically, see auth()
// above), no email/password/salt involved. See routes/stacksocial.js's
// /redeem-self.
export const apiRedeemStackSocialCodeSelf = (code) => post(`${BASE}/stacksocial/redeem-self`, { code });
export const apiSetLanguage = (language) => post(`${BASE}/profile/language`, { language });

// Chiave principale, tappa 2 — vedi utils/chiavePrincipale.js e
// ENCRYPTION-PLAN.md 3-ter. Il client manda la BUSTA, mai la chiave: dal
// server passano solo il salt della wrapping key e il blob incartato.
// `via` dice da quale dei sei punti di derivazione e' partita la migrazione,
// perche' login_log non e' in grado di distinguerli (vedi il limite
// documentato in fondo alla sezione 7 del piano).
export const apiMigraChiavePrincipale = ({ wrapSalt, wrappedMasterKey, verificata, via }) =>
  post(`${BASE}/auth/migrate-master-key`, { wrapSalt, wrappedMasterKey, verificata, via });

// Tappa 3 — un file cifrato VERO su cui provare la chiave recuperata, prima
// che il ripristino sovrascriva la password. Vedi routes/auth.js.
export const apiCampioneRecupero = (username, recoveryToken) =>
  post(`${BASE}/auth/recovery/campione`, { username, recoveryToken });

// I campioni per l'utente gia' autenticato: servono a provare la chiave PRIMA
// di incartarla. Vedi scegliCampioni() lato server.
export const apiCampioni = () => post(`${BASE}/auth/campioni`, {});

// Il registro dei rifiuti (2026-09-12). Chiamata a vuoto: non si aspetta
// niente dalla risposta e un errore qui non deve fermare niente — se il
// registro non riceve la riga, l'utente non se ne accorge e non deve.
export const apiMigrazioneRifiutata = (dati) =>
  post(`${BASE}/auth/migrazione-rifiutata`, dati).catch(() => null);

// Files
export const apiListFiles   = (folderId) => get(`${BASE}/files${folderId ? `?folderId=${folderId}` : ''}`);
export const apiListRecent  = ()          => get(`${BASE}/files/recent`);
export const apiListAllFiles = ()         => get(`${BASE}/files/all`);
// I PREFERITI (2026-09-18). Il filtro e l'ordine li fa il server: preferito_at
// non e' cifrato, quindi e' l'unica cosa del vault che il server puo'
// ordinare. I nomi restano illeggibili da quella parte come sempre.
// L'ANTEPRIMA (2026-09-19). Sale come multipart perche' sono byte, e scende
// dalla sua rotta con la stessa marca di versione dell'originale: quando il
// file cambia, cambia l'url e la vecchia in cache non viene piu' chiesta.
export async function apiSetAnteprima(fileId, { blob, iv }) {
  const fd = new FormData();
  fd.append('anteprima', blob, 'a.bin');
  fd.append('iv', iv);
  const res = await fetch(`${BASE}/files/${fileId}/anteprima`, { method: 'POST', headers: auth(), body: fd });
  if (!res.ok) throw new Error('anteprima non accettata');
  return res.json();
}
export const apiTogliAnteprima = (fileId) => del(`${BASE}/files/${fileId}/anteprima`);
export const urlAnteprima = (file) => {
  const marca = marcaVersione(file);
  return `${BASE}/files/${file.id}/anteprima${marca ? `?v=${encodeURIComponent(marca)}` : ''}`;
};
export async function apiScaricaAnteprima(file) {
  const res = await fetch(urlAnteprima(file), { headers: auth() });
  if (!res.ok) throw new Error('anteprima non disponibile');
  return res.blob();
}

export const apiListPreferiti = ()        => get(`${BASE}/files/preferiti`);
export const apiSetPreferito = (fileId, preferito) => patch(`${BASE}/files/${fileId}/preferito`, { preferito });
export const apiQuota       = ()          => get(`${BASE}/files/quota`);
// La didascalia viaggia GIA' CIFRATA: qui dentro passano due stringhe base64
// (testo cifrato e il suo iv) o due null per toglierla. Il server non la legge.
export const apiSetDidascalia = (fileId, dati) => patch(`${BASE}/files/${fileId}/didascalia`, dati);
export const apiDeleteFile = (id)       => del(`${BASE}/files/${id}`);
export const apiMoveFile   = (id, folderId) => patch(`${BASE}/files/${id}`, { folderId });


// INVIO CON AVANZAMENTO REALE (2026-09-12).
//
// Si usa XMLHttpRequest e non fetch per un motivo solo: fetch NON espone
// l'avanzamento della RICHIESTA. Espone quello della risposta, che per un
// caricamento e' l'ultimo istante e non serve a niente. xhr.upload.onprogress
// da' i byte davvero consegnati al socket, ed e' supportato ovunque.
//
// Misurato su un caricamento vero da 250 MB: cifratura circa 1 secondo, invio
// circa 140 secondi. La vecchia barra si fermava a 70 per tutto l'invio, cioe'
// per il 99% dell'attesa, e sembrava bloccata. I byte qui sono quelli del
// corpo della richiesta (file cifrato piu' i campi del modulo), quindi il
// conteggio e' leggermente superiore alla dimensione del file: si riporta il
// totale che dichiara il browser, non una stima.
function inviaConAvanzamento(url, fd, avanzamento, segnale) {
  return new Promise((risolvi, rifiuta) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    const h = auth();
    for (const k of Object.keys(h)) xhr.setRequestHeader(k, h[k]);
    if (avanzamento && xhr.upload) {
      xhr.upload.onprogress = (e) => {
        // lengthComputable e' false quando il browser non sa quanto e' grande
        // il corpo: si passa comunque i byte inviati, e chi disegna mostrera'
        // i megabyte senza percentuale invece di inventarne una.
        avanzamento({ inviati: e.loaded, totale: e.lengthComputable ? e.total : null });
      };
    }
    xhr.onload = () => {
      let data = {};
      try { data = JSON.parse(xhr.responseText || '{}'); } catch {}
      if (xhr.status >= 200 && xhr.status < 300) return risolvi(data);
      rifiuta(Object.assign(new Error(data.error || 'Upload failed'), {
        code: data.code, maxFiles: data.maxFiles, maxFileSize: data.maxFileSize,
        // La dimensione del piano, quando il server la manda: serve a scrivere
        // "hai finito il tuo piano da 1 TB" invece del testo inglese del
        // server, che era tutto quello che l'utente vedeva.
        quotaBytes: data.quotaBytes, usedBytes: data.usedBytes, fileCount: data.fileCount,
        status: xhr.status,
      }));
    };
    xhr.onerror = () => rifiuta(Object.assign(new Error('Upload failed'), { status: xhr.status || 0 }));
    xhr.onabort = () => rifiuta(Object.assign(new Error('Upload aborted'), { code: 'ABORTED' }));
    // L'annullo dalla coda arriva da qui: senza, premere Annulla fermava solo
    // l'interfaccia e la richiesta continuava a salire per conto suo.
    if (segnale) {
      if (segnale.aborted) { xhr.abort(); return; }
      segnale.addEventListener('abort', () => { try { xhr.abort(); } catch {} }, { once: true });
    }
    xhr.send(fd);
  });
}

export async function apiUploadFile({ blob, encryptedName, iv, size, mimeType, encrypted, folderId, plainName }, onProgress = null, segnale = null) {
  const fd = new FormData();
  fd.append('file', blob, 'upload.bin');
  fd.append('encrypted', String(encrypted));
  fd.append('size', String(size));
  fd.append('mimeType', mimeType || 'application/octet-stream');
  if (folderId) fd.append('folderId', folderId);
  if (encrypted) {
    fd.append('encryptedName', encryptedName);
    fd.append('iv', iv);
  } else {
    fd.append('plainName', plainName || '');
  }
  return inviaConAvanzamento(`${BASE}/files/upload`, fd, onProgress, segnale);
}

export async function apiReplaceFile(fileId, { blob, encryptedName, iv, size, mimeType, encrypted, plainName }, onProgress = null) {
  const fd = new FormData();
  fd.append('file', blob, 'upload.bin');
  fd.append('encrypted', String(encrypted));
  fd.append('size', String(size));
  fd.append('mimeType', mimeType || 'application/octet-stream');
  if (encrypted) {
    fd.append('encryptedName', encryptedName);
    fd.append('iv', iv);
  } else {
    fd.append('plainName', plainName || '');
  }
  return inviaConAvanzamento(`${BASE}/files/${fileId}/replace`, fd, onProgress);
}

// Version history
export const apiListVersions   = (fileId)             => get(`${BASE}/files/${fileId}/versions`);
export const apiRestoreVersion = (fileId, versionId)   => post(`${BASE}/files/${fileId}/versions/${versionId}/restore`, {});
export const apiDeleteVersion  = (fileId, versionId)   => del(`${BASE}/files/${fileId}/versions/${versionId}`);
export async function apiDownloadVersion(fileId, versionId) {
  const res = await fetch(`${BASE}/files/${fileId}/versions/${versionId}/download`, { headers: auth() });
  if (!res.ok) throw new Error('Download failed');
  const isEncrypted = res.headers.get('X-File-Encrypted') === 'true';
  return { blob: await res.blob(), isEncrypted };
}

// LA MARCA DI VERSIONE NELL'URL (2026-09-18).
//
// `versione` e' uploadedAt della riga. Serve a una cosa sola: rendere l'url
// diverso quando i byte cambiano. L'id del file NON cambia se il file viene
// sostituito o sovrascritto via WebDAV, quindi senza questa marca il browser
// servirebbe per sempre i byte vecchi (vedi la rotta in backend/routes/files.js).
// Con la marca il server risponde con una cache lunga e PRIVATA e la seconda
// apertura di una cartella non riscarica niente; senza, si resta a no-store.
export function marcaVersione(file) {
  const t = Date.parse(file?.uploadedAt || '');
  return Number.isFinite(t) ? String(t) : null;
}

export async function apiDownloadFile(fileId, versione = null) {
  const marca = versione ? `?v=${encodeURIComponent(versione)}` : '';
  const res = await fetch(`${BASE}/files/${fileId}/download${marca}`, { headers: auth() });
  if (!res.ok) throw new Error('Download failed');
  const isEncrypted = res.headers.get('X-File-Encrypted') === 'true';
  return {
    blob: await res.blob(),
    isEncrypted
    // iv and encryptedName are NOT read from headers (they can get corrupted in transit)
    // The caller uses its local file record instead
  };
}

// Folders
export const apiListFolders  = (parentId) => get(`${BASE}/files/folders${parentId ? `?parentId=${parentId}` : ''}`);
export const apiListAllFolders = () => get(`${BASE}/files/folders/all`);
export const apiCreateFolder = (name, parentId) => post(`${BASE}/files/folders`, { name, parentId: parentId || null });
export const apiDeleteFolder = (id)  => del(`${BASE}/files/folders/${id}`);
export const apiRenameFolder = (id, name) => patch(`${BASE}/files/folders/${id}`, { name });
// parentId null = riportala in radice. Si manda sempre la chiave, anche a
// null: il server distingue "non toccare il genitore" (chiave assente) da
// "mettila in radice" (chiave a null).
export const apiMoveFolder = (id, parentId) => patch(`${BASE}/files/folders/${id}`, { parentId: parentId ?? null });

// Payments
export const apiCreateCheckout = (plan, currency, promo, campaign) => post(`${BASE}/payments/checkout`, { plan, currency, ...(promo && { promo }), ...(campaign && { campaign }) });
// Post-registration upsell funnel (2026-08-28) — routes/analytics.js.
export const apiLogPostRegisterEvent = (event, plan, campaign) => post(`${BASE}/analytics/post-register-event`, { event, plan, campaign });
// In-app-browser checkout bridge (components/InAppBrowserWarning.jsx,
// pages/CheckoutBridgePage.jsx) — see routes/checkoutClaim.js for the
// server side. apiLogInAppCheckoutEvent/apiCreateCheckoutBridgeToken run
// authenticated, from inside the in-app browser; apiClaimCheckoutBridge runs
// with no session at all (the token itself is the credential) — reusing
// post() for it anyway is harmless, it just sends an unused/absent auth
// header the server-side route never checks.
export const apiLogInAppCheckoutEvent    = (event, plan, correlationId) => post(`${BASE}/checkout/inapp-event`, { event, plan, correlationId });
export const apiCreateCheckoutBridgeToken = (plan, correlationId, campaign) => post(`${BASE}/checkout/bridge-token`, { plan, correlationId, ...(campaign && { campaign }) });
export const apiClaimCheckoutBridge      = (token)                      => post(`${BASE}/checkout/bridge-claim`, { token });
export const apiVerifyPayment  = (sessionId) => get(`${BASE}/payments/verify/${sessionId}`);
export const apiPaymentHistory = ()          => get(`${BASE}/payments/history`);

// Admin
export const apiAdminUsers      = ()                    => get(`${BASE}/admin/users`);
export const apiAdminStats      = ()                    => get(`${BASE}/admin/stats`);
export const apiAdminPayments   = ()                    => get(`${BASE}/admin/payments`);
export const apiAdminChangePlan = (uid, plan, reason)   => post(`${BASE}/admin/users/${uid}/change-plan`, { plan, reason });
export const apiAdminPlanChangeLog = (uid)              => get(`${BASE}/admin/users/${uid}/plan-change-log`);
export const apiAdminStackSocialCodes = ()              => get(`${BASE}/admin/stacksocial-codes`);
export const apiAdminStackSocialTrend = ()              => get(`${BASE}/admin/stacksocial-codes/trend`);
// Il seriale va nel CORPO della POST, mai nell'URL (2026-09-16): nginx scrive
// l'URL di ogni richiesta in access.log, e cosi' ogni codice finiva in un log.
export const apiAdminStackSocialLookup = (code)         => post(`${BASE}/admin/stacksocial-codes/lookup`, { code });
export const apiAdminStackSocialApply = (code, userId)  => post(`${BASE}/admin/stacksocial-codes/apply`, { code, userId });
export const apiAdminBan        = (uid)                 => post(`${BASE}/admin/users/${uid}/ban`, {});
export const apiAdminUnban      = (uid)                 => post(`${BASE}/admin/users/${uid}/unban`, {});
export const apiAdminSetRole    = (uid, role)           => post(`${BASE}/admin/users/${uid}/role`, { role });
export const apiAdminDeleteUser = (uid)                 => del(`${BASE}/admin/users/${uid}`);
export const apiAdminPaymentReminder = (uid)            => post(`${BASE}/admin/users/${uid}/payment-reminder`, {});
export const apiAdminLogins     = (limit = 200)         => get(`${BASE}/admin/logins?limit=${limit}`);
export const apiAdminEmails     = (limit = 500)         => get(`${BASE}/admin/emails?limit=${limit}`);
export const apiAdminLiveVisits = ()                    => get(`${BASE}/admin/live-visits`);
export const apiAdminUploadStatus = ()                  => get(`${BASE}/admin/upload-status`);
export const apiAdminGetMaintenance = ()                => get(`${BASE}/admin/maintenance`);
export const apiAdminSetMaintenance = (enabled)         => post(`${BASE}/admin/maintenance`, { enabled });

// ─── Helpers ────────────────────────────────────────────────
// 2026-08-30 — every thrown error now carries either `status` (a real HTTP
// status code — the server responded, it just said no) or `isNetworkError:
// true` (fetch() itself rejected: offline, DNS failure, connection dropped
// or aborted mid-flight — the request never got a response at all). Before
// this, both cases threw an identical plain Error, so a caller like
// useAuth.js's session-restore effect had no way to tell "your token is
// invalid" apart from "the network hiccuped" — see that file's
// restoreSession for the consumer this was actually built for. Status is
// captured even when the body isn't valid JSON (e.g. nginx's own 502 HTML
// page when the app itself is down) — data just comes back null in that case.
async function request(url, opts) {
  let res;
  try {
    res = await fetch(url, opts);
  } catch (err) {
    throw Object.assign(new Error(err.message || 'Network error'), { isNetworkError: true });
  }
  let data = null;
  try { data = await res.json(); } catch {}
  // `codice` e `messaggio` viaggiano accanto al messaggio d'errore (2026-09-12):
  // il codice serve a chi deve DECIDERE cosa mostrare — per esempio il
  // recupero, che davanti a 'senza_chiave_recupero' e 'app_vecchia' deve dire
  // due cose diverse e nella lingua dell'utente, non ripetere una stringa
  // inglese arrivata dal server.
  if (!res.ok) throw Object.assign(new Error((data && data.error) || `Request failed (${res.status})`),
    { status: res.status, codice: data && data.error, messaggio: data && data.message });
  return data;
}
async function get(url, signal) { return request(url, { headers: auth(), signal }); }
async function post(url, body, signal) { return request(url, { method: 'POST', headers: { 'Content-Type': 'application/json', ...auth() }, body: JSON.stringify(body), signal }); }
async function del(url, signal) { return request(url, { method: 'DELETE', headers: auth(), signal }); }
async function patch(url, body, signal) { return request(url, { method: 'PATCH', headers: { 'Content-Type': 'application/json', ...auth() }, body: JSON.stringify(body), signal }); }

// Recovery
export const apiRecoveryVerify = (username, recoveryToken) =>
  post(`${BASE}/auth/recovery/verify`, { username, recoveryToken });
export const apiRecoveryReset = (data) =>
  post(`${BASE}/auth/recovery/reset`, data);
export const apiCancelSubscription = () => post(`${BASE}/payments/cancel-subscription`, {});
export const apiResumeSubscription  = () => post(`${BASE}/payments/resume-subscription`, {});
export const apiGetAnalytics = () => get(`${BASE}/analytics/stats`);
export const apiGetQuickStats = () => get(`${BASE}/analytics/quick-stats`);
export const apiTrackVisit = (page) => post(`${BASE}/analytics/visit`, { page });
export const apiRecoverySetup = (recoveryTokenHash, encryptedKeyBackup) =>
  post(`${BASE}/auth/recovery/setup`, { recoveryTokenHash, encryptedKeyBackup });
export const apiUpdateProfile = (data) => post(`${BASE}/auth/update-profile`, data);
export const apiUpdateEmail = (email) =>
  post(`${BASE}/auth/update-email`, { email });
export const apiUpdateUsername = (username) =>
  post(`${BASE}/auth/update-username`, { username });

// 2FA
export const api2faSetup   = ()      => post(`${BASE}/auth/2fa/setup`, {});
export const api2faEnable  = (code)  => post(`${BASE}/auth/2fa/enable`, { code });
export const api2faDisable = (pwd)   => post(`${BASE}/auth/2fa/disable`, { password: pwd });
export const api2faVerify  = (pendingToken, code) => post(`${BASE}/auth/login/2fa`, { pendingToken, code });

// WebDAV
export const apiWebdavStatus     = ()  => get(`${BASE}/profile/webdav`);
export const apiWebdavEnable     = ()  => post(`${BASE}/profile/webdav/enable`, {});
export const apiWebdavDisable    = ()  => post(`${BASE}/profile/webdav/disable`, {});
export const apiWebdavRegenerate = ()  => post(`${BASE}/profile/webdav/regenerate`, {});

export const apiBackupTokenStatus     = ()  => get(`${BASE}/profile/backup-token`);
export const apiBackupTokenEnable     = ()  => post(`${BASE}/profile/backup-token/enable`, {});
export const apiBackupTokenDisable    = ()  => post(`${BASE}/profile/backup-token/disable`, {});
export const apiBackupTokenRegenerate = ()  => post(`${BASE}/profile/backup-token/regenerate`, {});

// Support tickets
export const apiTicketsList   = ()                    => get(`${BASE}/tickets`);
export const apiTicketsGet    = (id)                   => get(`${BASE}/tickets/${id}`);
// Con allegati si usa multipart, senza si resta su JSON: il caso senza file
// e' la stragrande maggioranza e non deve cambiare comportamento.
// Nota: NIENTE Content-Type impostato a mano su FormData — il browser deve
// generarlo da se' includendo il boundary, altrimenti il server non riesce a
// separare le parti e non vede nessun file.
function ticketForm(campi, files) {
  const fd = new FormData();
  Object.entries(campi).forEach(([k, v]) => fd.append(k, v));
  (files || []).forEach((f) => fd.append('attachments', f));
  return fd;
}
export const apiTicketsCreate = (subject, message, files) => (files && files.length
  ? request(`${BASE}/tickets`, { method: 'POST', headers: auth(), body: ticketForm({ subject, message }, files) })
  : post(`${BASE}/tickets`, { subject, message }));
export const apiTicketsReply  = (id, message, files) => (files && files.length
  ? request(`${BASE}/tickets/${id}/reply`, { method: 'POST', headers: auth(), body: ticketForm({ message }, files) })
  : post(`${BASE}/tickets/${id}/reply`, { message }));

// L'allegato si scarica solo attraverso l'endpoint applicativo, che verifica
// chi chiede: non esiste un URL diretto al file. Serve il token, quindi si
// passa da fetch e si apre il blob ottenuto.
export async function apiTicketAttachment(ticketId, attId, nome, { admin = false } = {}) {
  const base = admin ? `${BASE}/admin/tickets` : `${BASE}/tickets`;
  const r = await fetch(`${base}/${ticketId}/attachments/${attId}`, { headers: auth() });
  if (!r.ok) throw new Error('download');
  const blob = await r.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = nome || 'allegato';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

// Anteprima per le immagini nel pannello: stesso endpoint verificato, ma il
// blob resta in memoria come object URL invece di essere scaricato.
export async function apiTicketAttachmentUrl(ticketId, attId, { admin = false } = {}) {
  const base = admin ? `${BASE}/admin/tickets` : `${BASE}/tickets`;
  const r = await fetch(`${base}/${ticketId}/attachments/${attId}`, { headers: auth() });
  if (!r.ok) throw new Error('preview');
  return URL.createObjectURL(await r.blob());
}

// Admin — Support tickets
export const apiAdminTickets     = ()                          => get(`${BASE}/admin/tickets`);
export const apiAdminTicketGet   = (id)                         => get(`${BASE}/admin/tickets/${id}`);
export const apiAdminTicketReply = (id, message, status)        => post(`${BASE}/admin/tickets/${id}/reply`, { message, status });
export const apiAdminTicketStatus = (id, status)                => patch(`${BASE}/admin/tickets/${id}/status`, { status });

// Family
export const apiFamilyGet          = ()      => get(`${BASE}/family`);
export const apiFamilyInvite       = (email) => post(`${BASE}/family/invite`, { email });
export const apiFamilyCancelInvite = (token) => del(`${BASE}/family/invite/${token}`);
export const apiFamilyAccept       = (token) => post(`${BASE}/family/accept`, { token });
export const apiFamilyRemoveMember = (id)    => del(`${BASE}/family/members/${id}`);
export const apiFamilyLeave        = ()      => post(`${BASE}/family/leave`, {});
// Public — no auth token available yet when previewing an invite link
export async function apiFamilyInvitePreview(token) {
  const res = await fetch(`${BASE}/family/invite/${token}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Invito non valido');
  return data;
}

// Referral program
export const apiReferralsGet    = ()      => get(`${BASE}/referrals`);
export const apiReferralsInvite = (email) => post(`${BASE}/referrals/invite`, { email });

// Shares — shareable links for files/folders
export const apiSharesList  = ()     => get(`${BASE}/shares`);
export const apiSharesCreate = (data) => post(`${BASE}/shares`, data);
export const apiSharesDelete = (id)   => del(`${BASE}/shares/${id}`);

export async function apiShareAddItem(shareId, { blob, relPath, iv, encryptedName, size, mimeType }) {
  const fd = new FormData();
  fd.append('file', blob, 'item.bin');
  fd.append('relPath', relPath);
  fd.append('iv', iv);
  fd.append('encryptedName', encryptedName);
  fd.append('size', String(size));
  fd.append('mimeType', mimeType || 'application/octet-stream');
  const res = await fetch(`${BASE}/shares/${shareId}/items`, { method: 'POST', headers: auth(), body: fd });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Upload failed');
  return data;
}

// Public — no auth token, used on the recipient-facing share page
export async function apiSharePublicGet(id) {
  const res = await fetch(`${BASE}/shares/public/${id}`);
  const data = await res.json();
  if (!res.ok) throw Object.assign(new Error(data.error || 'Link not found'), { status: res.status });
  return data;
}
export async function apiSharePublicDownload(id, itemId) {
  const res = await fetch(`${BASE}/shares/public/${id}/download/${itemId}`);
  if (!res.ok) { const data = await res.json().catch(() => ({})); throw new Error(data.error || 'Download failed'); }
  return res.blob();
}

// ── Posti (admin) ──────────────────────────────────────────────────────
export const apiAdminPosti          = ()               => get(`${BASE}/admin/posti`);
export const apiAdminPostiAggiungi  = (plan, quanti)   => post(`${BASE}/admin/posti/${plan}/aggiungi`, { quanti });
export const apiAdminPostiImposta   = (plan, rimasti)  => post(`${BASE}/admin/posti/${plan}/imposta`, { rimasti });
